import { useState } from 'react';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { createUploadUrlAssetType } from '@api/assetTypes';
import { uploadFileToGcloud } from '@api/common';

import { handleErrorFromMessage } from '@utils/handleRequestError';
import { generateHeaders } from '@utils/headersMapper';

import { ESnackbarTypes } from '@enums/common';

import { HUNDRED_PERCENT_LOADING } from '@constants/common';
import { UPLOAD_LOGO_URL } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateUploadAssetIcon = (onSuccessCallback: (id?: string) => void) => {
	const [progress, setProgress] = useState<number>(HUNDRED_PERCENT_LOADING);

	const dispatch = useAppDispatch();

	const {
		mutate: createUploadIconUrl,
		isLoading: isLoadingCreateUploadIconUrl,
	} = useMutation({
		mutationKey: [UPLOAD_LOGO_URL],
		mutationFn: ({ file }: { file: File }) => {
			createUploadUrlAssetType(file.name).then((data: any) => {
				const headers = generateHeaders(data?.headers);
				const url = data?.uploadUrl;

				uploadFileToGcloud({ url, data: file, headers, onProgressHandler: setProgress }).then(() => {
					onSuccessCallback(data?.importId);
				}).catch((err) => {
					dispatch(setSnackbar({
						message: err?.message || responseMessages.error,
						type: ESnackbarTypes.error,
					}));
				});
			}).catch(err => handleErrorFromMessage(err));
		},
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.uploadLogo,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return {
		createUploadIconUrl,
		isLoadingCreateUploadIconUrl,
		progress,
	};
};
